import i18n from 'i18next';
import resources from '../assets';

const enableDebug = !!process.env['ENABLE_TRANSLATION_DEBUG'] || false;
const fallbackLanguages = {
    'en-ca': ['en-au', 'en-gb', 'en-us'],
    'en-nz': ['en-au', 'en-gb', 'en-us'],
    'en-au': ['en-gb', 'en-us'],
    'en-ie': ['en-gb', 'en-us'],
    'en-in': ['en-gb', 'en-us'],
    'en-sg': ['en-gb', 'en-us'],
    'en-gb': ['en-us'],
    'fr-be': ['fr-fr', 'en-us'],
    'fr-ca': ['fr-fr', 'en-us'],
    'fr-ch': ['fr-fr', 'en-us'],
    'es-us': ['es-es', 'en-us'],
    'nl-be': ['nl-nl', 'en-us'],
    'de-at': ['de-de', 'en-us'],
    'de-ch': ['de-de', 'en-us'],
    'it-ch': ['it-it', 'en-us'],
    default: ['en-us'],
};

i18n.init({
    resources,
    debug: enableDebug,
    fallbackLng: fallbackLanguages,
    lowerCaseLng: true, //locales are set to lower case e.g. "en-us" not "en-US"
    interpolation: {
        escapeValue: false, // React already provides escaping
    },
    nsSeparator: '*****', // namespace selector is a string delimited which defaults to ":". Overriding to *** so that urls don't get split
    returnObjects: true,
});

export default i18n;
